package amazon.lastmile.inject

import app.nestbridge.feature.home.presentation.HomePresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = HomePresenterFactory::class)
public interface AppNestbridgeFeatureHomePresentationHomePresenterFactory {
  @Provides
  @IntoSet
  public fun provideHomePresenterFactoryFactoryMultibinding(homePresenterFactory: HomePresenterFactory): Presenter.Factory = homePresenterFactory
}
